import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import ReactStrapTable from "components/reactStrapTable";
import Arrow from "assets/icon/LeftChevron.svg";
import useAxios from "hooks/useAxios";
import { dateFormate } from "utils/columns";
import { cloneDeep } from "lodash";
import Confirm from "components/Confirm";
import { toast } from "react-toastify";
import { Field } from "formik";
import FormikSelectField from "components/common/Fields/FormikSelectField";

const lookBackPeriodOpt = [
    { lookBackPeriod: 30, label: "30 Days" },
    { lookBackPeriod: 60, label: "60 Days" },
    { lookBackPeriod: 90, label: "90 Days" },
    { lookBackPeriod: 120, label: "120 Days" },
  ];
const ConfigurationRules = ({
  setRowConfig,
  setConfigRules,
  setClientCongigToggle,
  thirdPartyAdminID,
  SelectedChainPharmacyvalue,
}) => {
  const API = useAxios();
  const [chainLevelData, setChainLevelData] = useState([]);
  const [lookBackData, setLookBackData] = useState([]);
  const [isConfirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [individualData, setIndvidualData] = useState([]);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [itemChecked, setItemChecked] = useState("");
  const [isCancleButtonEnabled, setIsCancleButtonEnabled] = useState(false);
  const handelClickimage = () => {
    //setEditConfigToggle(false);
    setRowConfig(true);
    setClientCongigToggle(false);
    setConfigRules(false);
  };

  useEffect(() => {
    if (thirdPartyAdminID != 0 && SelectedChainPharmacyvalue != "") {
      fetchDrugConfig();
    }
  }, [thirdPartyAdminID, SelectedChainPharmacyvalue]);

  const refetch = () => {
    fetchDrugConfig();
  };

  const fetchDrugConfig = async () => {
    try {
      const { data } = await API.get(
        `GWConfig/Configuration/DrugContractConfig/${thirdPartyAdminID}/${SelectedChainPharmacyvalue}`,
        {
          hasDefaultURL: true,
        }
      );
      if (data) {
        const chainLvelData = data.filter(item => item.code != "LBP");
        setChainLevelData(chainLvelData);
        const lookBackData = data.filter(item => item.code == "LBP");
        setLookBackData(lookBackData);
      }
    } catch (error) {}
  };

  const handleSwitch = (e, item) => {
    let data = cloneDeep(item);
    if (item.code == "LBP") {
      data.defaultConfigValue = e.target.value;
    } else {
      data.checked = e.target.checked;
    }
    setIndvidualData(data);
    handleSaveConfirmation();
  };
  const handleSaveConfirmation = () => {
    setConfirm(!isConfirm);
  };
  const handlesave = async () => {
    setConfirm(!isConfirm);
    setIndvidualData(individualData);
    let payload = individualData;
    try {
      const data = await API.post(
        `GWConfig/Configuration/SaveDrugContractConfig/${thirdPartyAdminID}/${SelectedChainPharmacyvalue}`,
        payload,
        {
          hasDefaultURL: true,
        }
      );
      if (data) {
        toast.success("Rules saved successfully");
       
        refetch();
      } else {
      }
    } catch (err) {
    }
  };

  return (
    <div>
      <Card className="border-0 shadow-top my-3">
        <CardBody className="section-devider-border">

          {/* <hr /> */}
          <div className="table-card scroll-table position-relative border-0 rounded pt-0 mt-2">
            <div className="rounded-table">
              <div className="table-responsive">
                <table
                  style={{ zIndex: "1" }}
                  id="reactstrap-table"
                  className="table table-striped theme-table undefined table"
                >
                  <thead>
                    <tr>
                      <th width="120">Options</th>
                      <th width="140">Rule Name</th>
                      <th width="380">Description</th>
                      <th width="120">Modified Date</th>
                      <th width="180">Modified By</th>
                    </tr>
                  </thead>
                  {chainLevelData.map((item) => {
                    return (
                      <tbody>
                        <tr>
                          {(
                            <td className="">
                              <FormGroup switch>
                                <Input
                                  type="switch"
                                  role="switch"
                                  className="f-20 m-auto"
                                  style={{ margin: "auto" }}
                                  //disabled={item.disabled}
                                  checked={
                                    item.defaultConfigValue == "Y"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => handleSwitch(e, item)}
                                />
                              </FormGroup>
                            </td>
                          )}
                          <td>{item.ruleName}</td>
                          <td>{item.ruleDescription}</td>
                          <td>{dateFormate(item?.modifiedDate)}</td>
                          <td>{item?.modifiedBy}</td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              </div>
            </div>
          </div>
          <hr />
          <Row>
            <Col md="2">
              <FormGroup>
                <Label>Look Back Period</Label>
                <Input
                  id="LBP"
                  name="LBP"
                  type="select"
                  autoComplete="off"
                  value={lookBackData ? lookBackData[0]?.defaultConfigValue : ""}
                  options={lookBackPeriodOpt}
                  keys={{
                    id: "lookBackPeriod",
                    label: "label",
                  }}
                  onChange={(e) => handleSwitch(e, lookBackData[0])}
                >
                  {/* <option value="">--Select--</option> */}
                  {lookBackPeriodOpt.map((option) => (
                    <option
                      key={option.lookBackPeriod}
                      value={option.lookBackPeriod}
                    >
                      {option.label}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>

        </CardBody>
      </Card>
      <Confirm
        isOpen={isConfirm}
        loading={loading}
        message="Do you want to Proceed?"
        onToggle={handleSaveConfirmation}
        onCancel={handleSaveConfirmation}
        onContinue={handlesave}
      />
    </div>
  );
};

export default ConfigurationRules;
